export const EcommerceQueryKeys = {
  CompanyStandards: "ecommerce-company-standards",
  StorefrontCompanyStandards: "ecommerce-storefront-company-standards",
  CatalogRules: "ecommerce-catalog-rules",
  CatalogNavPaths: "ecommerce-catalog-nav-paths",
  PostExtendedSearchProducts: "ecommerce-post-extended-search-products",
  GetExtendedCatalogProductDetails:
    "ecommerce-get-extended-catalog-product-details",
  StandardsShop: "ecommerce-standards-shop",
  ProductDetails: "ecommerce-product-details",
  PendingOrders: "ecommerce-order-approvals-pending",
  OrderApprovalCounts: "ecommerce-order-approval-counts",
  ProductDetailsDrawer: "ecommerce-product-details-drawer",
  ProductDetailsDrawerImages: "ecommerce-product-details-drawer-images",
  ProductAvailability: "ecommerce-product-availability",
  AutoPopulatePreference: "ecommerce-auto-populate-preference",
  PostWarehouseProductSearch: "ecommerce-post-warehouse-product-search",
  ManufacturerSearch: "ecommerce-manufacturer-search",
  StorefrontBundles: "ecommerce-storefront-bundles",
  StorefrontBundle: "ecommerce-storefront-bundle",
  StorefrontBundleStatuses: "ecommerce-storefront-bundle-statuses",
} as const;
